export const PRODUCTLINK = [
  {
    key: 'https://laas.santasmartnetwork.com/ssh5/index.html',
    channel: 'laas',
    bucket: 'laas',
    domain: 'https://laas.santasmartnetwork.com',
  },
  {
    key: 'https://grotto.santasmartnetwork.com/ssh5/index.html',
    channel: 'grotto',
    bucket: 'grotto',
    domain: 'https://grotto.santasmartnetwork.com',
  },
  {
    key: 'https://ewe.santasmartnetwork.com/ssh5/index.html',
    channel: 'ewe',
    bucket: 'bxl-ewe',
    domain: 'https://ewe.santasmartnetwork.com',
  },
]

export const BASE_LINK = {
  link: 'https://baleen-cdn-g.bybieyang.com/static/html/byh5/index.html',
}
// 排序查询
export const SORT_TYPE = [
  { value: 'sales', label: 'bestSelling' },
  { value: 'discount', label: 'discount' },
  { value: 'recency', label: 'newest' },
  { value: 'metrics.popularScore', label: 'hottest' },
  { value: 'metrics.sales1Day', label: 'daySelling1' },
  { value: 'metrics.sales3Days', label: 'daySelling3' },
  { value: 'metrics.sales7Days', label: 'daySelling7' },
  { value: 'metrics.sales30Days', label: 'daySelling30' },
  { value: 'metrics.sales90Days', label: 'daySelling90' },
  { value: 'metrics.multiPurchaseIndex', label: 'repurchase' },
  { value: 'metrics_praise_products', label: 'rank' },
]

export const BXL_USER_ID = 'x-session-user'
export const BXL_USER_KEY = 'x-session-key'

// deeplink 类型
export const DEEPLINK_TYPE = {
  WEBVIEW_H5: 'WEBVIEW_H5',
  SEARCH_PRODUCT: 'SEARCH_PRODUCT',
  ARTICLE_DETAIL: 'ARTICLE_DETAIL',
  ARTICLE_HASHTAG: 'ARTICLE_HASHTAG',
  ARTICLE_SEARCH: 'ARTICLE_SEARCH',
  PRODUCT_DETAIL: 'PRODUCT_DETAIL',
  PRODUCT_LIST: 'PRODUCT_LIST',
  COUPON_LIST: 'COUPON_LIST',
  INVITE_CODE: 'INVITE_CODE',
  MERCHANT_DETAIL: 'MERCHANT_DETAIL',
  BRANKINFOPAGE: 'BRANKINFOPAGE',
}

export const DEEPLINK_OPTIONS = [
  {
    label: 'Webview(H5页面)',
    value: DEEPLINK_TYPE.WEBVIEW_H5,
    path: 'wvp',
  },
  { label: '商品搜索页', value: DEEPLINK_TYPE.SEARCH_PRODUCT, path: 'plp' },
  {
    label: '文章详情页(包括短手)',
    value: DEEPLINK_TYPE.ARTICLE_DETAIL,
    path: 'cdp',
  },
  { label: '文章Hashtag', value: DEEPLINK_TYPE.ARTICLE_HASHTAG, path: 'cht' },
  { label: '文章检索结果页', value: DEEPLINK_TYPE.ARTICLE_SEARCH, path: 'csp' },
  { label: '产品详情页', value: DEEPLINK_TYPE.PRODUCT_DETAIL, path: 'pdp' },
  { label: '代金券列表', value: DEEPLINK_TYPE.COUPON_LIST, path: 'clp' },
  { label: '邀请好友页', value: DEEPLINK_TYPE.INVITE_CODE, path: 'icp' },
  { label: '商家详情页', value: DEEPLINK_TYPE.MERCHANT_DETAIL, path: 'mip' },
  {
    label: '品牌落地页',
    value: DEEPLINK_TYPE.BRANKINFOPAGE,
    path: 'brand',
  },
]

export const DOWNLOAD_LINK = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.borderxlab.bieyang'

export const merchantCategories = [
  {
    id: 'merchants_european_origin',
    value: 'merchants_european_origin',
    label: '欧洲商家',
  },
  {
    id: 'merchants_european_shipping_origin',
    value: 'merchants_european_shipping_origin',
    label: '欧洲发货地商家',
  },
  {
    id: 'SELLER_SHOP',
    value: 'SELLER_SHOP',
    label: 'bgm商家',
  },
  {
    id: 'PARTNER_SHOP',
    value: 'PARTNER_SHOP',
    label: '传统商家',
  },
  {
    id: 'RETURN_SALE',
    value: 'RETURN_SALE',
    label: '退货商品商家',
  },
  {
    id: 'SELF_SHOP',
    value: 'SELF_SHOP',
    label: '别样自营',
  },
  {
    id: 'merchants_china',
    value: 'merchants_china',
    label: '中国商家',
  },
  {
    id: 'merchants_china_taiwan',
    value: 'merchants_china_taiwan',
    label: '中国台湾商家',
  },
  {
    id: 'merchants_china_hong_kong',
    value: 'merchants_china_hong_kong',
    label: '中国香港商家',
  },
  {
    id: 'merchants_china_macao',
    value: 'merchants_china_macao',
    label: '中国澳门商家',
  },
  {
    id: 'merchants_hong_kong',
    value: 'merchants_hong_kong',
    label: '香港商家',
  },
  {
    id: 'merchants_australian',
    value: 'merchants_australian',
    label: '澳大利亚商家',
  },
  {
    id: 'merchants_austria',
    value: 'merchants_austria',
    label: '奥地利商家',
  },
  {
    id: 'merchants_canada',
    value: 'merchants_canada',
    label: '加拿大商家',
  },
  {
    id: 'merchants_finland',
    value: 'merchants_finland',
    label: '芬兰商家',
  },
  {
    id: 'merchants_french',
    value: 'merchants_french',
    label: '法国商家',
  },
  {
    id: 'merchants_holland',
    value: 'merchants_holland',
    label: '荷兰商家',
  },
  {
    id: 'merchants_italy',
    value: 'merchants_italy',
    label: '意大利商家',
  },
  {
    id: 'merchants_korea',
    value: 'merchants_korea',
    label: '韩国商家',
  },
  {
    id: 'merchants_spain',
    value: 'merchants_spain',
    label: '西班牙商家',
  },
  {
    id: 'merchants_uk',
    value: 'merchants_uk',
    label: '英国商家',
  },
  {
    id: 'merchants_us',
    value: 'merchants_us',
    label: '美国商家',
  },
  {
    id: 'merchants_germany',
    value: 'merchants_germany',
    label: '德国商家',
  },
  {
    id: 'merchants_japan',
    value: 'merchants_japan',
    label: '日本商家',
  },
  {
    id: 'shipping_and_tax_included',
    value: 'shipping_and_tax_included',
    label: '包邮包税商家',
  },
]
